import(/* webpackMode: "eager" */ "C:\\wamp64\\www\\cyberstone\\components\\Button\\button.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\wamp64\\www\\cyberstone\\components\\IndustryCard\\IndustryCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "C:\\wamp64\\www\\cyberstone\\node_modules\\next\\dist\\client\\app-dir\\link.js");
